import React from 'react'
import {Button, Card, Col, Drawer, Form, Icon, notification, Row, Table, Select, Upload, Tabs} from 'antd'
import _ from 'lodash'

import {FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request, {API_URL} from '../../request'
import {connect} from 'react-redux'
import moment from 'moment'
const Option = Select.Option

@Form.create()
class ViewUserAttendence extends React.Component {
    state = {
        visible: true,
        loading: false,
        userAttendance:[]
    }

    async componentDidMount() {
        let {record} = this.props
        let params = {}
        params.count = 10000
        params.results = 10000
        params.userId = record.userId
        params.time = {
            from:moment(record.attendanceYearMonth, 'YYYY-MM').startOf('month'),
            to:moment(record.attendanceYearMonth, 'YYYY-MM').endOf('month')
        }
        let response = await Request.getUserAttendance({...params})
        this.setState({userAttendance:response.data})
    }


    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }


    render() {

        const {
            form: {getFieldDecorator, getFieldValue}
        } = this.props
        const {visible, userAttendance } = this.state
        const {record} = this.props
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            {moment(record.attendanceYearMonth).format('MMMM-YYYY')} Attendence Report
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={500}
                visible={visible}>
                <Card>
                    <table style={{width:'100%'}}>
                        <tbody>
                            <tr>
                                <th>Attendance Date</th>
                                <th>Total Hours</th>
                            </tr>
                            {
                                userAttendance.map((attendence)=>{
                                    return(
                                        <tr>
                                            <td>{moment(attendence._id.attendanceDate).format('DD-MM-YYYY')}</td>
                                            <td>{attendence.totalHours}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewUserAttendence)
